<div class="container d-flex flex-column align-items-center">
  <img class="mt-5 pt-2 img-fluid" src="/assets/images/pencil.png" alt="" />
  <div class="text-center">
    <h1 class="error-heading">oops!</h1>
    <p class="error-msg">
      We can't seem to find the page<br />
      you're looking for.
    </p>
    <p class="error-code">Error code: 404</p>
    <a class="btn btn-filled-sm button-sm px-3" [href]="url"> Back to Home </a>
  </div>
</div>
